import { render, staticRenderFns } from "./OptionGroup.vue?vue&type=template&id=fd394520&scoped=true&"
import script from "./OptionGroup.vue?vue&type=script&lang=ts&"
export * from "./OptionGroup.vue?vue&type=script&lang=ts&"
import style0 from "./OptionGroup.vue?vue&type=style&index=0&id=fd394520&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd394520",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\rafael\\Github\\MultiSelect\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fd394520')) {
      api.createRecord('fd394520', component.options)
    } else {
      api.reload('fd394520', component.options)
    }
    module.hot.accept("./OptionGroup.vue?vue&type=template&id=fd394520&scoped=true&", function () {
      api.rerender('fd394520', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MultiSelect/OptionGroup.vue"
export default component.exports